module.exports = __webpack_public_path__ + "static/apple-touch-icon-fdbed05d7c6a136b3077d9e55db517d0.png";